import { EpicRefined } from 'interfaces/middleware'
import { VideoCallAction, AgoraSetActiveSpeakerAction } from 'components/features/videoCalls/types/actions'
import { mergeMap, map, filter } from 'rxjs/operators'
import { of, EMPTY } from 'rxjs'
import { filterAgoraClientEvent } from 'components/features/videoCalls/helpers'


export const volumeIndicatorEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterAgoraClientEvent('volume-indicator'),
  mergeMap((event) => of(null).pipe(
    map(() => event.attr || null),
    filter((attr): attr is NonNullable<typeof attr> => !!(attr && attr.length)),
    mergeMap((attr) => {
      const { videoCall } = store.getState().app
      const { speakerStreamId } = videoCall.details
      const { streamId } = videoCall.localStream

      const nextSpeakerStreamId = attr
        .map(({ uid, level }) => ({ uid: +uid, level }))
        .filter((item) => item.uid !== streamId)
        .sort((a, b) => b.level - a.level)[0]?.uid ?? null

      const isNewSpeaker = nextSpeakerStreamId !== speakerStreamId
      if (nextSpeakerStreamId && isNewSpeaker) {
        return of(new AgoraSetActiveSpeakerAction(nextSpeakerStreamId))
      }

      return EMPTY
    })
  )),
)
